﻿import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import axios from "axios";
import Loading from "../../Loading/Loading";
import WarrantyCard from "./warrantycard";
import { Typeahead } from 'react-bootstrap-typeahead';
import './warrantyprodfilter.scss';

class WarrantyProdFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            search: "",
            filter: [],
            loading: false,
            result: null
        };

        this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
        this.getAutocompleteProducts = this.getAutocompleteProducts.bind(this);
        //this.sortAutocompleteVals = this.sortAutocompleteVals(this);
    }

    componentDidMount() {
        this.getData();
    }

    getData() {
        console.log("Calling getData")
        const apiUrl = `${this.props.apiUrl}${this.state.search}`;

        this.setState({ loading: true });

        axios.post(apiUrl).then((res) => {
            this.setState({
                result: res.data,
                loading: false
            })
        });
    }

    handleSearchInputChange(arrValue) {
        //const value = ev.target.value;
        let singleVal = arrValue[0];

        if (arrValue.length > 0) {
            this.setState({
                search: singleVal,
                filter: arrValue
            });
        }
        else {
            this.setState({
                search: "",
                filter: arrValue
            })
        }

    }

    getAutocompleteProducts() {
        if (this.state.result !== null) {
            var pArray = [].concat.apply([], this.state.result.map((x) => x.AccessoryToProducts)).filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });

            for (var i = 0; i < pArray.length; i++) {
                pArray[i] = pArray[i].replace("=", "");
            }

            return pArray.sort();
        }

        return [];
    }

    // sortAutocompleteVals(a, b, value) {
    //     const aLower = a.toLowerCase()
    //     const bLower = b.toLowerCase()
    //     const valueLower = value.toLowerCase()
    //     const queryPosA = aLower.indexOf(valueLower)
    //     const queryPosB = bLower.indexOf(valueLower)
    //     if (queryPosA !== queryPosB) {
    //       return queryPosA - queryPosB
    //     }
    //     return aLower < bLower ? -1 : 1
    //   }


    render() {
        let filterResult;
        let searchVal = this.state.search;
        console.log("Search val", searchVal)

        if (searchVal === "") {
            filterResult = this.state.result;
        } else {
            filterResult = this.state.result.filter(function (item) {
                return item.AccessoryToProducts.some(function (d) {
                    return d.toLowerCase().includes(searchVal.toLowerCase());
                });
            });
        }

        return (
            <div id="filterwarrantyapp">

                <Typeahead
                    id="basic-typeahead-single"
                    labelKey="name"
                    onChange={this.handleSearchInputChange}
                    options={this.getAutocompleteProducts()}
                    placeholder="Choose a product..."
                    selected={this.state.filter}
                />

                {/* <input type="text" 
                        value={this.state.search} 
                        onChange={this.handleSearchInputChange} 
                        placeholder="Model name"
                        className="projectorinput serialnumber minimalist"
                        /> */}

                {this.state.result === null ? (
                    <div><Loading /></div>
                ) : (
                    <div id="results">{filterResult.map((e, i) => <WarrantyCard key={i} productName={e.ProductName} url={e.ProductUrl} />)}</div>
                )}

            </div>
        )
    }

}

const htmlElement = document.getElementById("app");
ReactDOM.render(
    <WarrantyProdFilter apiUrl={htmlElement.dataset.apiurl}
        instructions={htmlElement.dataset.instructions}
        searchText={htmlElement.dataset.searchtext}
    />,
    htmlElement
);